export default defineNuxtRouteMiddleware(({ meta }) => {
  const { hideBanner } = meta
  const { signedIn, isAdmin, afterRegisterCompanyInfo } = useAuth()
  const bannerModal = useBanner(DISPLAY_LOCATION_ADMIN_POST_LOGIN_MODAL)
  const bannerModeless = useBanner(DISPLAY_LOCATION_ADMIN_POST_LOGIN_MODELESS)

  if (
    !hideBanner && // バナー非表示ページではない
    signedIn.value && // ログイン済み
    !isAdmin.value && // 管理者でない
    afterRegisterCompanyInfo.value // 企業情報登録済み
  ) {
    bannerModal.loadBanners()
    bannerModeless.loadBanners()
  } else {
    bannerModal.clearBanners()
    bannerModeless.clearBanners()
  }

  return true
})
